/*
  Vin som hos Den Sidste Flaske – pris og antal på kortene i kollektionerne.
  Lytter på hele dokumentet, så det også virker på kort, som temaet indsætter igen (filtrering, sortering).

  Kort (snippets/wine-mix-card.liquid): antalsvælgeren .wm-card__qty skifter stykpris, overstreget pris, total og
  "Spar X kr". Kortet har kun fire grundtal (data-wm-data: normalpris, sammenligningspris, 6- og 12-kassepris i øre),
  og prisen for et antal regnes her med samme regler og afrunding som snippets/wine-mix-prices.liquid:
    under 6 normalpris · fra 6 6-prisen · fra 12 12-prisen (kun når kasseprisen findes)
    Trinnet = det største af antallet og Bland Selv-flaskerne i kurven (5. grundtal) – aldrig summen. Ændres kurven, hentes
    antallet fra /cart?view=mm-count (templates/cart.mm-count.liquid), og kortenes priser regnes igen. Når kurven når 6
    eller 12, forvælges 1 flaske (som snippets/wine-mix-prices.liquid, når siden indlæses med 6+ i kurven).
    stykpris = kassepris ÷ kassestørrelse, total = antal × kassepris ÷ kassestørrelse, begge afrundet til øre.
    Stykprisen vises præcist med ører, aldrig afrundet til hele kroner.
  Beløb formateres efter data-wm-money (Shopifys egen formatering af 1.234,56), så valuta og tegn passer.
  Skrevet uden nyere syntaks (fx ?.), så det kører på ældre iPhones og browsere.
*/
(function () {

  /* ---------- Ens titelhøjde i hver række ----------
     Titler i samme række får samme højde som den højeste, så beskrivelsen under starter på samme linje.
     Køres ved indlæsning, ændring af vinduets størrelse og når temaet skifter kortene ud (filtrering/sortering). */
  const equalizeTitles = () => {
    const titles = [...document.querySelectorAll('.product-card--wine-mix .wm-card__title')];
    if (!titles.length) return;
    titles.forEach((title) => { title.style.minHeight = ''; });
    const rows = []; /* [{ top, titles }] – kort inden for 4 px regnes som samme række (afrunding) */
    titles.forEach((title) => {
      const top = title.closest('.product-card').getBoundingClientRect().top + window.scrollY;
      let row = rows.find((candidate) => Math.abs(candidate.top - top) < 4);
      if (!row) rows.push(row = { top, titles: [] });
      row.titles.push(title);
    });
    rows.forEach(({ titles: row }) => {
      if (row.length < 2) return;
      const max = Math.max(...row.map((title) => title.getBoundingClientRect().height));
      row.forEach((title) => { title.style.minHeight = `${max}px`; });
    });
  };

  /* Højst hver 150 ms (ikke "vent til der er stille"): andre scripts ændrer siden løbende, så en debounce kunne vente for evigt */
  let equalizeTimer = null;
  const scheduleEqualize = () => {
    if (equalizeTimer || !document.querySelector('.product-card--wine-mix')) return; /* sider uden kort: intet arbejde */
    equalizeTimer = setTimeout(() => {
      equalizeTimer = null;
      equalizeTitles();
    }, 150);
  };
  window.addEventListener('load', scheduleEqualize);
  window.addEventListener('resize', scheduleEqualize);
  /* Kun på sider med kort: se efter, når temaet skifter kortene ud (filtrering, sortering, "vis flere"), og når anbefalinger
     og "Senest viste produkter" hentes efter indlæsningen (de har ingen kort, når siden er klar) */
  document.addEventListener('DOMContentLoaded', () => {
    const targets = [...document.querySelectorAll('product-recommendations, recently-viewed-products')];
    const list = document.querySelector('.product-card--wine-mix');
    if (list) targets.push(list.closest('.shopify-section') || document.body);
    if (!targets.length) return;
    scheduleEqualize();
    const observer = new MutationObserver(scheduleEqualize);
    targets.forEach((target) => observer.observe(target, { childList: true, subtree: true }));
  });

  /* ---------- Formatering som butikkens money_without_trailing_zeros ---------- */
  var formatters = {};
  /* keep = vis altid decimaler (temaets valutakode: money_with_currency), ellers fjernes ",00" som money_without_trailing_zeros */
  var getFormatter = function (sample, keep) {
    var key = sample + (keep ? '|keep' : '');
    if (formatters[key]) return formatters[key];
    var withDecimals = sample.match(/^([\s\S]*?)1([^0-9]?)234([^0-9])56([\s\S]*)$/);
    var noDecimals = withDecimals ? null : sample.match(/^([\s\S]*?)1([^0-9]?)235([\s\S]*)$/);
    var group = function (whole, separator) {
      return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };
    var formatter;
    if (withDecimals) {
      formatter = function (cents) {
        var whole = Math.floor(cents / 100);
        var fraction = cents % 100;
        return withDecimals[1] + group(whole, withDecimals[2]) + (fraction || keep ? withDecimals[3] + (fraction < 10 ? '0' : '') + fraction : '') + withDecimals[4];
      };
    } else if (noDecimals) {
      formatter = function (cents) {
        return noDecimals[1] + group(Math.round(cents / 100), noDecimals[2]) + noDecimals[3];
      };
    } else {
      formatter = function (cents) {
        return (cents / 100).toFixed(2);
      };
    }
    formatters[key] = formatter;
    return formatter;
  };

  /* ---------- Pris for et antal (samme regler som snippets/wine-mix-prices.liquid) ---------- */
  /* Kurven løfter kun prisen til det trin, kurven ALLEREDE har nået (6 i kurven + 6 = 6-prisen, ikke 12-prisen):
     siden må aldrig vise en pris, kurven ikke viser */
  var priceFor = function (data, quantity) {
    var count = Math.max(quantity, data.inCart || 0);
    var tier = data.box12 > 0 && count >= 12 ? 12 : (data.box6 > 0 && count >= 6 ? 6 : 1);
    var box = tier === 12 ? data.box12 : data.box6;
    var each = tier === 1 ? data.base : Math.floor((box * 2 + tier) / (tier * 2));
    var total = tier === 1 ? quantity * data.base : Math.floor((quantity * box * 2 + tier) / (tier * 2));
    return { each: each, total: total, save: each < data.ref ? data.ref - each : 0, mix: quantity < tier, tier: tier };
  };

  /* ---------- Kort ---------- */
  /* Stykpris, overstreget pris, total og "Spar X kr"-badget (data-wm-badge fra snippets/product-badges.liquid) for kortets antal */
  var updateCard = function (select) {
    var card = select.closest('.wm-card');
    var source = card ? card.querySelector('[data-wm-data]') : null;
    if (!source) return;

    var numbers = source.getAttribute('data-wm-data').split(',').map(function (value) { return parseInt(value, 10) || 0; });
    var data = { base: numbers[0], ref: numbers[1], box6: numbers[2], box12: numbers[3], inCart: numbers[4] };
    var quantity = parseInt(select.value, 10);
    if (!data.base || !quantity) return;

    var format = getFormatter(source.getAttribute('data-wm-money') || '', source.getAttribute('data-wm-decimals') === 'keep');
    var price = priceFor(data, quantity);

    var each = card.querySelector('[data-wm-each]');
    if (each) {
      each.textContent = format(price.each);
      each.classList.toggle('text-on-sale', price.save > 0);
    }
    var regular = card.querySelector('[data-wm-regular]');
    if (regular) regular.hidden = price.save <= 0;
    var total = card.querySelector('[data-wm-total]');
    if (total) total.textContent = format(price.total);
    var mix = card.querySelector('[data-wm-mix]');
    if (mix) {
      mix.hidden = !price.mix || !mix.getAttribute('data-title-' + price.tier); /* mærket ved 6 og 12 */
      /* Samme tekst som boksen i kurven: "SÅDAN! Du har låst op for 6-/12-flaskeprisen!" (hængelåsen står efter teksten) */
      var mixText = mix.querySelector('[data-wm-mix-text]');
      var title = mix.getAttribute('data-title-' + price.tier);
      if (price.mix && mixText && title) mixText.textContent = title;
    }

    var label = card.querySelector('[data-wm-qty-label]');
    if (label) label.textContent = select.value;

    /* Prisfelterne "1 flaske / 6 flasker / 12 flasker": hvert felt viser stykprisen, kurven giver for det antal (fx "1 flaske" =
       6-prisen med 6 i kurven). Fremhævet: feltet for det valgte antal – ellers trinnet (fx 7 flasker = "6 flasker") */
    var tiles = card.querySelectorAll('[data-wm-tile]');
    var quantityIsTile = !!card.querySelector('[data-wm-tile="' + quantity + '"]');
    tiles.forEach(function (tile) {
      var size = parseInt(tile.getAttribute('data-wm-tile'), 10);
      var tilePrice = tile.querySelector('[data-wm-tile-price]');
      if (tilePrice) tilePrice.textContent = format(priceFor(data, size).each);
      var active = quantityIsTile ? quantity === size : price.tier === size;
      tile.classList.toggle('is-active', active);
      tile.setAttribute('aria-pressed', String(active));
    });

    var badge = card.querySelector('[data-wm-badge]');
    if (badge) {
      badge.hidden = price.save <= 0;
      /* Hele besparelsen for antallet (normalpris × antal − total), fx 6 × 45 = 270 kr */
      if (price.save > 0) badge.innerHTML = badge.getAttribute('data-template').replace('__S__', format(data.ref * quantity - price.total));
    }
  };

  /* Pakkevælger (spiritus i 2/3-pakker, snippets/wine-mix-card.liquid): pris og total for den valgte pakke */
  document.addEventListener('change', function (event) {
    var pack = event.target && event.target.closest ? event.target.closest('.wm-card__pack') : null;
    var option = pack ? pack.options[pack.selectedIndex] : null;
    var card = pack ? pack.closest('.wm-card') : null;
    if (!option || !card) return;
    var each = card.querySelector('[data-mp-each]');
    if (each) {
      each.textContent = option.getAttribute('data-each');
      each.classList.toggle('text-on-sale', option.getAttribute('data-sale') === 'true');
    }
    var regular = card.querySelector('[data-mp-regular]');
    if (regular) regular.hidden = option.getAttribute('data-sale') !== 'true';
    var total = card.querySelector('[data-mp-total]');
    if (total) total.textContent = option.getAttribute('data-total');
  });

  /* Varianter som valgknapper (flere varianter, én valgmulighed – fx Ron Dos Mares' gratis XO-rom): pris for den valgte */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio' || !input.closest || !input.closest('.wm-card__variants')) return;
    var card = input.closest('.wm-card');
    if (!card) return;
    var sale = input.getAttribute('data-sale') === 'true';
    var each = card.querySelector('[data-mp-each]');
    if (each) {
      each.textContent = input.getAttribute('data-each');
      each.classList.toggle('text-on-sale', sale);
    }
    var regular = card.querySelector('[data-mp-regular]');
    if (regular) {
      regular.textContent = input.getAttribute('data-regular') || '';
      regular.hidden = !sale;
    }
  });

  /* Tryk på et prisfelt: antallet sættes til 1, 6 eller 12 (og prisen/totalen følger med via "change") */
  document.addEventListener('click', function (event) {
    var tile = event.target && event.target.closest ? event.target.closest('[data-wm-tile]') : null;
    var card = tile ? tile.closest('.wm-card') : null;
    var select = card ? card.querySelector('.wm-card__qty') : null;
    if (!select) return;
    var value = tile.getAttribute('data-wm-tile');
    if (!select.querySelector('option[value="' + value + '"]')) return;
    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Kunden skifter antal */
  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest('.wm-card__qty') : null;
    if (!select) return;
    updateCard(select);
  });

  /* Kurven ændret: nyt antal Bland Selv-flasker i kurven på alle kort (kun kort med Bland Selv-trin, 6-kasse > 0) */
  var refreshInCart = function () {
    if (!document.querySelector('.wm-card [data-wm-data]')) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart?view=mm-count', { cache: 'no-store' })
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var inCart = parseInt(text, 10);
        if (isNaN(inCart)) return;
        document.querySelectorAll('.wm-card').forEach(function (card) {
          var source = card.querySelector('[data-wm-data]');
          var select = card.querySelector('.wm-card__qty');
          if (!source || !select) return;
          var numbers = source.getAttribute('data-wm-data').split(',');
          if (!(parseInt(numbers[2], 10) > 0)) return;
          /* Kurven når et nyt trin (6+ eller 12+): 1 flaske forvælges, som når siden indlæses med 6+ i kurven */
          var before = parseInt(numbers[4], 10) || 0;
          var reached = (before < 6 && inCart >= 6) || (parseInt(numbers[3], 10) > 0 && before < 12 && inCart >= 12);
          if (reached && select.querySelector('option[value="1"]')) select.value = '1';
          numbers[4] = String(inCart);
          source.setAttribute('data-wm-data', numbers.join(','));
          updateCard(select);
        });
      })
      .catch(function () { /* opdateres ved næste sidevisning */ });
  };
  document.addEventListener('cart:change', refreshInCart);
  document.addEventListener('cart:refresh', refreshInCart);

  /* ---------- Antalsliste (som Den Sidste Flaske) ----------
     Knappen .wm-qty__toggle åbner listen .wm-qty__list over kortet med "N flasker • stykpris" for hvert antal; et valg
     sætter den skjulte select og sender "change", så prisen på kortet følger med (updateCard). */
  var closeQtyLists = function (except) {
    document.querySelectorAll('.wm-qty__list:not([hidden])').forEach(function (list) {
      if (list === except) return;
      list.hidden = true;
      var toggle = list.parentNode.querySelector('.wm-qty__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  };
  var fillQtyList = function (form, list) {
    var card = form.closest('.wm-card');
    var source = card ? card.querySelector('[data-wm-data]') : null;
    var select = form.querySelector('.wm-card__qty');
    if (!source || !select) return;
    var numbers = source.getAttribute('data-wm-data').split(',').map(function (value) { return parseInt(value, 10) || 0; });
    var data = { base: numbers[0], ref: numbers[1], box6: numbers[2], box12: numbers[3], inCart: numbers[4] };
    var format = getFormatter(source.getAttribute('data-wm-money') || '', source.getAttribute('data-wm-decimals') === 'keep');
    list.querySelectorAll('.wm-qty__option').forEach(function (option) {
      var quantity = parseInt(option.getAttribute('data-value'), 10);
      var each = option.querySelector('[data-wm-qty-each]');
      if (each && data.base && quantity) each.textContent = format(priceFor(data, quantity).each);
      option.setAttribute('aria-selected', String(option.getAttribute('data-value') === select.value));
    });
  };
  var chooseQty = function (option) {
    var form = option.closest('.wm-card__form');
    var select = form ? form.querySelector('.wm-card__qty') : null;
    if (!select) return;
    select.value = option.getAttribute('data-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));
    closeQtyLists();
    var toggle = form.querySelector('.wm-qty__toggle');
    if (toggle) toggle.focus();
  };
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var toggle = target.closest('.wm-qty__toggle');
    if (toggle) {
      var form = toggle.closest('.wm-card__form');
      var list = form ? form.querySelector('.wm-qty__list') : null;
      if (!list) return;
      var open = list.hidden;
      closeQtyLists(list);
      if (open) fillQtyList(form, list);
      list.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        var current = list.querySelector('[aria-selected="true"]') || list.querySelector('.wm-qty__option');
        if (current) current.focus();
      }
      return;
    }
    var option = target.closest('.wm-qty__option');
    if (option) {
      chooseQty(option);
      return;
    }
    if (!target.closest('.wm-qty__list')) closeQtyLists();
  });
  /* Tastatur: pil op/ned flytter i listen, Enter/mellemrum vælger, Escape lukker */
  document.addEventListener('keydown', function (event) {
    var option = event.target && event.target.closest ? event.target.closest('.wm-qty__option') : null;
    if (event.key === 'Escape') {
      var openList = document.querySelector('.wm-qty__list:not([hidden])');
      if (!openList) return;
      var toggle = openList.parentNode.querySelector('.wm-qty__toggle');
      closeQtyLists();
      if (toggle) toggle.focus();
      return;
    }
    if (!option) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      chooseQty(option);
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      var next = event.key === 'ArrowDown' ? option.nextElementSibling : option.previousElementSibling;
      if (next) next.focus();
    }
  });
})();
